import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { GlobalState } from "little-state-machine";

export const updateCompleteWorkOrderPageOrigination = (
  state: GlobalState,
  viewCompleteWorkOrderPageOrigination
  : RoutePathsEnum
) => ({
  ...state,
  viewCompleteWorkOrderPageOrigination
});
